/* eslint-disable max-len */
import 'react';

const ImportSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg width="1em" height="1em" viewBox="0 0 46 46" {...props}>
        <g fill="none" fillRule="evenodd">
            <path d="M0 0h46v46H0z" />
            <path
                d="M32.538 9c2.347 0 4.27 1.768 4.449 4.013l.013.34v19.294c0 2.29-1.812 4.166-4.114 4.34l-.348.013H15.27c-2.797 0-5.065-2.212-5.065-4.941 0-.78.648-1.412 1.447-1.412.72 0 1.316.512 1.429 1.183l.019.229c0 1.08.828 1.97 1.898 2.101l.272.016h17.267c.787 0 1.439-.565 1.55-1.303l.018-.226V13.353c0-.768-.58-1.404-1.337-1.513l-.231-.016H15.27c-1.106 0-2.02.807-2.153 1.852l-.017.265c0 .78-.648 1.412-1.448 1.412-.799 0-1.447-.632-1.447-1.412 0-2.61 2.075-4.748 4.704-4.929L15.27 9h17.267zm-9.263 8.637l.179.153 3.65 3.65c.84.84.915 2.148.215 3.037l-.175.198-3.56 3.56c-.552.551-1.457.54-2.022-.025a1.437 1.437 0 01-.174-1.846l.148-.176 1.668-1.668-12.77-.108c-.798-.007-1.44-.645-1.434-1.424a1.424 1.424 0 011.225-1.383l.235-.017 12.907.109-1.91-1.91a1.437 1.437 0 01-.174-1.847l.149-.175a1.423 1.423 0 011.843-.128z"
                fill="#5C6473"
            />
        </g>
    </svg>
);

export default ImportSvg;
